/**
 * Utility for determining API base URL
 */

// Get the base API URL based on environment
export const getApiBaseUrl = () => {
  return window.location.hostname === 'localhost' 
    ? 'http://localhost:3000'
    : 'https://api.tradingcard.life';
};

// Export a configured API base URL
export const API_BASE_URL = getApiBaseUrl();